import * as React from "react";
const SvgFiRrStepBackward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-step-backward_svg__a)">
      <path
        fill="#062147"
        d="M18.809.44c-1.374-.695-2.934-.566-4.204.368L5.001 8.483V1a1 1 0 1 0-2 0v22a1 1 0 1 0 2 0v-7.482l9.637 7.706a3.95 3.95 0 0 0 2.354.784 4 4 0 0 0 1.818-.44A3.93 3.93 0 0 0 21 20.001V4.007A3.93 3.93 0 0 0 18.809.44M19 20.001a1.94 1.94 0 0 1-1.094 1.783 1.99 1.99 0 0 1-2.053-.145L5.816 13.611A1.98 1.98 0 0 1 5 12.001c0-.645.298-1.232.816-1.612L15.82 2.396A1.96 1.96 0 0 1 16.99 2c.307 0 .616.075.915.226A1.94 1.94 0 0 1 19 4.008z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-step-backward_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStepBackward;
